const devConfig = require('./index.dev');

module.exports = {
  ...devConfig,
  environment: 'staging',
  baseURL: 'https://dev--frontend.rupiahtoken.com'
};
